export default "__VITE_ASSET__dGn4G3tR__"